import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { SystemHealthDashboard } from '@/components/admin/SystemHealthDashboard';

export const Route = createFileRoute('/admin/health')({
  component: AdminHealthPage,
});

function AdminHealthPage(): React.JSX.Element {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">System Health</h1>
          <p className="text-muted-foreground mt-2">
            Monitor the health and performance of all system services
          </p>
        </div>
        <SystemHealthDashboard />
      </div>
    </AdminLayout>
  );
}
